import { useState } from 'react';
import { SociogramApi } from '@BUP/services/Axios';

export const useCreateQuestionResponse = ({ enrollmentId, surveyId }) => {
  const [listState, setListState] = useState({
    loadingResponse: false,
    dataResponse: {},
    errorResponse: null,
  });

  const handleCreateResponse = (response) =>
    SociogramApi.post('/responses', response);

  // formatea las response a la estructura solictada en la api
  const formatResponses = (responses) => {
    return responses.map((response) => ({
      surveyId,
      enrollmentId,
      question_id: response?.question?.id,
      answerId: response?.id,
      response_content:
        response?.content.map((ele) => ({ enrrollmentId: ele.enrollmentId })) ||
        null,
    }));
  };

  const saveAllResponsesByPage = async (responses) => {
    setListState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    try {
      const formatedResponses = formatResponses(responses);
      const allRequest = formatedResponses.map((response) =>
        handleCreateResponse(response)
      );
      const requestResponse = await Promise.all(allRequest);
      console.log('saveAllResponsesByPage responses', requestResponse);
    } catch (error) {
      console.log(error);
      setListState((prevState) => ({
        ...prevState,
        errorResponse: error.message,
      }));
    } finally {
      setListState((prevState) => ({
        ...prevState,
        loading: false,
      }));
    }
  };

  return {
    loadingResponse: listState.isLoading,
    dataResponse: listState.data,
    errorResponse: listState.error,
    saveAllResponsesByPage,
    formatResponses,
  };
};
